/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type ApplicationCreateRequestStatus =
    (typeof ApplicationCreateRequestStatus)[keyof typeof ApplicationCreateRequestStatus];

export const ApplicationCreateRequestStatus = {
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    NOT_STARTED: 'NOT_STARTED'
} as const;
